var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.936a.99.99 0 0 0-.778-.363H1.188a.21.21 0 0 1-.136-.052A.162.162 0 0 1 1 9.405V5.17c0-.046.02-.084.052-.117a.16.16 0 0 1 .136-.052h6.64c1.673.001 3.12.689 4.339 2.057l1.614 1.971-3.144 3.833L8.25 9.937zm11.608-2.899c1.212-1.355 2.665-2.036 4.357-2.036h6.621a.166.166 0 0 1 .123.04.15.15 0 0 1 .038.13v4.234a.18.18 0 0 1-.038.117.136.136 0 0 1-.124.053h-6.283a.99.99 0 0 0-.779.363l-4.63 5.635 4.65 5.676a.985.985 0 0 0 .752.337h6.284a.145.145 0 0 1 .123.052.21.21 0 0 1 .039.136v4.235a.18.18 0 0 1-.04.117.136.136 0 0 1-.122.052h-6.615c-1.692 0-3.132-.688-4.338-2.056l-3.852-4.701-3.852 4.701c-1.212 1.368-2.665 2.056-4.358 2.056H1.188a.145.145 0 0 1-.123-.052.178.178 0 0 1-.04-.136V21.75a.18.18 0 0 1 .04-.115.136.136 0 0 1 .123-.052h6.284c.298 0 .583-.136.778-.363l4.546-5.551 7.062-8.633z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnx);
export default __webpack_public_path__ + "static/media/SNX.803b74172f2db3c4a908e0bf0ec57580.svg";
export { ForwardRef as ReactComponent };